export type OwnedResource = {
  createdBy?: string | null;
  created_by?: string | null;
  CreatedBy?: string | null;
  ownerId?: string | null;
  owner_id?: string | null;
  /** Server-computed write access (snake_case payloads: agents, tools list, KB). */
  can_edit?: boolean | null;
  /** Server-computed write access (camelCase models: skills, packs, prompts). */
  canEdit?: boolean | null;
  /** Server-computed write access (PascalCase payloads: tool detail, KB folders). */
  CanEdit?: boolean | null;
};

export function resolveCreatedBy(
  resource?: string | null | OwnedResource
): string | null {
  if (resource == null) return null;
  if (typeof resource === 'string') return resource || null;
  return (
    resource.createdBy ??
    resource.created_by ??
    resource.CreatedBy ??
    resource.ownerId ??
    resource.owner_id ??
    null
  );
}

export function isOwner(
  createdBy?: string | null,
  currentUserId?: string | null
): boolean {
  if (!createdBy || !currentUserId) return false;
  return createdBy === currentUserId;
}

/**
 * Server-provided write access, or null when the backend hasn't sent one.
 * Never re-implement the rule client-side — org-admin rights depend on
 * OrgId / SharedOrgIds / PlatformManaged, which the FE cannot see.
 */
export function resolveCanEdit(
  resource?: string | null | OwnedResource
): boolean | null {
  if (resource == null || typeof resource === 'string') return null;
  const flag = resource.can_edit ?? resource.canEdit ?? resource.CanEdit;
  return flag == null ? null : flag;
}

/** Prefers the server flag; falls back to creator comparison pre-BE. */
export function canEditResource(
  resource?: string | null | OwnedResource,
  currentUserId?: string | null
): boolean {
  return (
    resolveCanEdit(resource) ?? isOwner(resolveCreatedBy(resource), currentUserId)
  );
}
